import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/Home.css";

const Home = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="home-container">
      <div className="hero">
        <h1>Asset Management System</h1>
        <p>Track and manage all your organization's assets efficiently</p>
        {isAuthenticated ? (
          <Link to="/assets" className="btn btn-lg btn-primary">
            Go to Assets
          </Link>
        ) : (
          <Link to="/login" className="btn btn-lg btn-primary">
            Login to Get Started
          </Link>
        )}
      </div>

      <div className="features">
        <div className="feature">
          <h3>Track Assets</h3>
          <p>
            Keep track of all your IT hardware, printers, and network devices
          </p>
        </div>
        <div className="feature">
          <h3>Dynamic Properties</h3>
          <p>Add custom properties specific to each asset type</p>
        </div>
        <div className="feature">
          <h3>Easy Management</h3>
          <p>Create, update, and manage assets with an intuitive interface</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
